import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PedigreeChartView from 'src/components/pedigree-chart/PedigreeChartView';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function FhqPreviewModal({
  open,
  onClose,
  shadowFamilyId,
  realFamilyId
}) {
  const t = useAutoTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 1.25
        }}
      >
        <Typography component="span" sx={{ fontWeight: 600 }}>
          {t('FHQ Pedigree Preview')}
          {realFamilyId ? ` (${realFamilyId})` : ''}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label={t('Close')}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ position: 'relative', width: '100%', height: '72vh' }}>
          {open && shadowFamilyId && (
            <PedigreeChartView
              previewFamilyId={shadowFamilyId}
              onPreviewError={onClose}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
